export {default} from './Sider';



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Sider/index.ts